import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Extra_income from "./extra_income/Extra_income";
import Choose_us from "./choose_us/Choose_us";
import How_to_join from "./how_to_join/How_to_join";
import Make_difference from "./make_difference/Make_difference";
import Download_app from "./download_app/Download_app";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function Home() {
  const location = useLocation();
  // Scroll to the top when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <Banner />
      <Extra_income />
      <Choose_us />
      <How_to_join />
      <Make_difference />
      <Download_app />
    </>
  );
}

export default Home;
